import { api } from '../../../services/api/apiClient';
import type { ApiResponse } from '../../../types/api';
import type { AttendanceEntry, AttendanceRegister, AttendanceSheet } from '../types/attendanceTypes';

export const attendanceService = {
  /** Register for one day ("YYYY-MM-DD"). */
  register: (date: string) => api.get<ApiResponse<AttendanceRegister>>('/attendance', { date }).then((r) => r.data),
  /** Month grid ("YYYY-MM"). */
  sheet: (month: string) => api.get<ApiResponse<AttendanceSheet>>('/attendance/sheet', { month }).then((r) => r.data),
  save: (date: string, entries: AttendanceEntry[]) => api.put('/attendance', { date, entries }).then((r) => r.data),
};
